// The profile page stores the owner on userData. Discover cards read userId,
// name, and description from the top of the profile object.
export function asDiscoverProfile(profileInfo: any, userInfo?: any) {
    if (!profileInfo) return null;

    const nestedUser = profileInfo.userData?._id ? profileInfo.userData : null;
    const fallbackUser = userInfo?.userData?._id ? userInfo.userData : null;
    const userData = nestedUser || fallbackUser;

    return {
        ...profileInfo,
        userId: profileInfo.userId || userData?._id || null,
        username: profileInfo.username || userData?.username || userInfo?.username,
        firstName: profileInfo.firstName ?? userData?.firstName ?? userInfo?.firstName ?? null,
        lastName: profileInfo.lastName ?? userData?.lastName ?? userInfo?.lastName ?? null,
        displayName: profileInfo.displayName ?? userData?.displayName ?? userInfo?.displayName ?? null,
        description: profileInfo.description || profileInfo.bio || null,
        userData: userData || profileInfo.userData,
    };
}
